/* eslint-disable import/prefer-default-export */
import PageNotFound from '../components/templates/PageNotFound'

const commonRouterConfig = {
  routes: [
    {
      component: PageNotFound
    }
  ]
}

const getRouterConfig = async (countryName, baseUrl) => {
  const routeConfig = await import(`../components/pages/${countryName}/router.config.js`)
  const allRouters = [...routeConfig.default.routes, ...commonRouterConfig.routes]

  return allRouters.map((route) => {
    if (route.isRedirect) {
      return {
        ...route,
        from: `${baseUrl}${route.from}`,
        to: `${baseUrl}${route.to}`
      }
    }
    return {
      ...route,
      url: route.url ? `${baseUrl}${route.url}` : ''
    }
  })
}

export { getRouterConfig }
